const getLocalStorageKey = (key) => {
  const item = window.localStorage.getItem(key)
  return item && item !== 'undefined' ? JSON.parse(item) : null
}
const setLocalStorageKey = (key, state) => {
  window.localStorage.setItem(key, JSON.stringify(state))
}
const deleteLocalStorageKey = (key) => {
  setLocalStorageKey(key, null)
  // extra precaution
  window.localStorage.removeItem(key)
}

const getSessionKey = (key) => {
  const item = window.sessionStorage.getItem(key)
  return item && item !== 'undefined' ? JSON.parse(item) : null
}
const setSessionKey = (key, state) => {
  window.sessionStorage.setItem(key, JSON.stringify(state))
}
const deleteSessionKey = (key) => {
  setSessionKey(key, null)
  // extra precaution
  window.sessionStorage.removeItem(key)
}

/**
 * This function first retrieves all keys from localStorage, then iterates
 * through them.
 *
 * If a key is not in the keysToKeep array, it removes that key from
 * localStorage.
 */
const clearLocalStorageExcept = (keysToKeep) => {
  // Get all keys from localStorage
  const allKeys = Object.keys(window.localStorage)

  // Loop through all keys
  allKeys.forEach((key) => {
    // If the key is not in the keysToKeep array, remove it from localStorage
    if (!keysToKeep.includes(key)) {
      deleteLocalStorageKey(key)
    }
  })
}

export {
  getLocalStorageKey,
  setLocalStorageKey,
  deleteLocalStorageKey,
  getSessionKey,
  setSessionKey,
  deleteSessionKey,
  clearLocalStorageExcept,
}
